const cadViewerSetting = process.env.VUE_APP_ENABLE_CAD_VIEWER;

export const CAD_VIEWER_ENABLED = cadViewerSetting === 'true';